import TableCustom from "../../ui/table/TableCustom";
import {
    ORDER_TYPE_PENDING,
    ORDER_TYPE_PENDING_SEARCH,
    useStoreTransmissions,
} from '../../../store/useStoreTransmissions.ts'
import {useActionButtons} from '../../../hooks/transmissions/useActionButtons.ts'
import Loader from '../../ui/loader/Loader';
import ModalCustom from '../../ui/modal/ModalCustom';

export const TransmissionsTab = () => {
    const isLoading = useStoreTransmissions(state => state.isLoading);
    const type = useStoreTransmissions(state => state.type);
    const transmissions = useStoreTransmissions(state => state.transmissions);
    const isError = useStoreTransmissions(state => state.isError);
    const sortType = useStoreTransmissions(state => state.sortType);
    const sortOrder = useStoreTransmissions(state => state.sortOrder);
    const setSortOrder = useStoreTransmissions((state) => state.setSortOrder)
    const setSortType = useStoreTransmissions((state) => state.setSortType)

    const {
        actionButtons,
        actionPendingButtons,
        handleShowOrder,
        modalContent,
        showModalInformation,
        modalSize,
        modalBodyClass,
        modalFooter,
        modalTitle,
        setShowModalInformation,
        buttons,
    } = useActionButtons()

    function isEnattente() {
        return [ORDER_TYPE_PENDING, ORDER_TYPE_PENDING_SEARCH].includes(type)
    }

    function getHearders(): Array<string> {
        return isEnattente()
            ? [
                  "Date d'envoi",
                  'Date et moment de livraison',
                  'Destinataire',
                  'Code postal ville',
                  'Montant',
                  'Actions',
              ]
            : [
                  'Etat',
                  "Date d'envoi",
                  'Numéro',
                  'Destinataire',
                  'Livraison',
                  'Code postal ville',
                  'Montant',
                  'Exécutant',
                  'Actions',
              ];
    }

    function buildSorting(): Array<string> {
        return isEnattente()
            ? ['datliv', 'nomdes', 'localite', 'montantcdee', 'codex']
            : [
                  'etatextranet',
                  'date',
                  'numcde',
                  'nomdes',
                  'datliv',
                  'localite',
                  'amountvat',
                  'codex',
              ]
    }

    function handleSortOrder(newSortOrder: string): void {
        const sort = sortOrder === 'asc' ? 'desc' : 'asc'

        if (newSortOrder !== sortType) {
            sort = 'asc'
        }
        setSortOrder(sort);
        setSortType(newSortOrder);
    }

    function buildConfig(): Array<object> {
        return isEnattente()
            ? [
                  {
                      type: 'date',
                      key: 'date',
                  },
                  {
                      type: 'multilines',
                      key: [
                          {type: 'date', key: 'datliv'},
                          {type: 'text', key: 'momentjourvalue'},
                      ],
                  },
                  {type: 'text', key: 'nomdes'},
                  {
                      type: 'multilines',
                      key: [
                          {type: 'text', key: 'codpostal'},
                          {type: 'text', key: 'localite'},
                      ],
                  },
                  {type: 'currency', key: 'amountvat'},
                  {
                      type: 'buttons',
                      key: actionPendingButtons,
                      view: true,
                  },
              ]
            : [
                  {
                      type: 'picto',
                      key: 'etatextranet',
                  },
                  {
                      type: 'date',
                      key: 'date',
                  },
                  {
                      type: 'multilines',
                      key: [
                          {
                              type: 'link_modal',
                              key: 'numcde',
                              defaultKey: 'idsgribouil',
                              func: handleShowOrder,
                              funcParam: ['numcde', 'idsgribouil'],
                          },
                      ],
                  },
                  {
                      type: 'text',
                      key: 'nomdes',
                  },
                  {
                      type: 'multilines',
                      key: [
                          {type: 'date', key: 'datliv'},
                          {type: 'text', key: 'momentjourvalue'},
                      ],
                  },
                  {
                      type: 'multilines',
                      key: [
                          {type: 'text', key: 'codpostal'},
                          {type: 'text', key: 'localite'},
                      ],
                  },
                  {type: 'currency', key: 'amountvat'},
                  {
                      type: 'multilines',
                      key: [
                          {type: 'text', key: 'codex'},
                          {type: 'phone', key: 'telseek', array: 'extra'},
                      ],
                  },
                  {
                      type: 'buttons',
                      key: actionButtons,
                  },
              ]
        ;
    }
    
    return (
        <>
            <TableCustom
                id={'transmissionsList'}
                isLoading={isLoading}
                headers={getHearders()}
                data={transmissions}
                isError={isError}
                sorting={buildSorting()}
                handleSortOrder={handleSortOrder}
                sortType={sortType}
                sortOrder={sortOrder}
                config={buildConfig()}
            />

            {isLoading && <Loader />}

            <ModalCustom
                show={showModalInformation}
                id={'executions-modal'}
                onHide={() => setShowModalInformation(false)}
                size={modalSize}
                title={modalTitle}
                titleClassname={modalTitle ? 'px-3 pb-2' : 'text-center mb-3'}
                header={false}
                bodyClassname={modalBodyClass}
                content={<>{modalContent}</>}
                footer={modalFooter}
                buttonsFooter={[
                    ...buttons,
                    ...[
                        {
                            text: 'Fermer',
                        },
                    ],
                ]}
            />
        </>
    )
}
